<template>
  <v-container>
    <v-row class="text-center">
      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Terminal Operator Access Permit Form
          <template v-if="access_permit.cargo_type">
            for {{ access_permit.cargo_type }}
          </template>
        </h2>
      </v-col>
      <v-col
        cols="auto"
        sm12
        md6
        md="4"
      >
        <v-radio-group v-model="access_permit.cargo_type">
          <v-radio
            v-for="(type,i) in cargo_types"
            :key="i"
            :label="type"
            :value="type"
          />
        </v-radio-group>
        <v-card
          class="pa-2"
          outlined
          raised
        >
          <v-form ref="form">
            <GenericDatePicker
              :model="access_permit.request_date"
              label="Pickup/Delivery date*"
              @update:return-value="e => (access_permit.request_date = e)"
            />
            <GenericTextField
              :model="access_permit.customs_agent.sur_name"
              label="Surname Customs agent*"
            />
            <GenericTextField
              :model="access_permit.customs_agent.given_name"
              label="Given Name Customs agent*"
            />
            <GenericTextField
              :model="access_permit.customs_agent.assistant.sur_name"
              label="Surname Assistant/Co-assistant"
            />
            <GenericTextField
              :model="access_permit.customs_agent.assistant.given_name"
              label="Given Name Assistant/Co-assistant"
            />
            <template v-if="access_permit.cargo_type === 'Container'">
              <AccessPermitRequestContainer />
            </template>
            <template v-if="access_permit.cargo_type === 'Vehicle'">
              <AccessPermitRequestVehicle />
            </template>
            <template v-if="access_permit.cargo_type === 'Other'">
              <AccessPermitRequestOther />
            </template>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GenericTextField from '../components/GenericTextField';
import GenericDatePicker from '../components/GenericDatePicker';
import AccessPermitRequestContainer from '../components/AccessPermitRequestContainer';
import AccessPermitRequestVehicle from '../components/AccessPermitRequestVehicle';
import AccessPermitRequestOther from '../components/AccessPermitRequestOther';

export default {
  name: 'TerminalOperatorAccessPermit',
  components: {
    AccessPermitRequestOther,
    AccessPermitRequestVehicle,
    AccessPermitRequestContainer,
    GenericDatePicker,
    GenericTextField,
  },
  data: () => ({
    ecosystem: [
      {
        text: 'Havenbeheer',
        href: 'https://havenbeheer.com/',
      },
      {
        text: 'github',
        href: 'https://github.com/vuetifyjs/vuetify',
      },
      {
        text: 'awesome-vuetify',
        href: 'https://github.com/vuetifyjs/awesome-vuetify',
      },
    ],
    access_permit: {
      cargo_type: '',
      request_date: new Date().toISOString().substr(0, 10),
      customs_agent: {
        sur_name: '',
        given_name: '',
        assistant: {
          sur_name: '',
          given_name: '',
        },
      },
      terminal_operator: '',
      purpose_of_visit: '',
      vessel_name: '',
      shipper: '',
      cargo_category: '',
      container_nr: '',
      cargo_container_size: '',
      cargo_container_type: '',
      status: '',
      gewicht: '',
      inhoud: '',
      truck_nr: '',
      Chauffeur: '',
      bijzonderheden: '',
    },
    cargo_categories: [
      'Break bulk',
      'Liquid bulk',
      'Dry bulk',
      'Ro-Ro Cargo',
      'Container/ Unitizised Cargo',
    ],
    cargo_types: [
      'Container',
      'Vehicle',
      'Other',
    ],
  }),
};
</script>
